var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500",
      "persistent": ""
    },
    on: {
      "click:outside": _vm.handleCancel
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-bell-outline")]), _vm._v(" Enable Push Notifications ")], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('p', {
    staticClass: "mb-4"
  }, [_vm._v(" Get instant notifications about auditions, reminders, and important updates even when the app is closed. ")]), _c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "type": "info",
      "outlined": "",
      "dense": ""
    }
  }, [_c('small', [_c('strong', [_vm._v("Note:")]), _vm._v(" You'll be asked to allow notifications in your browser. Make sure to click \"Allow\" to receive push notifications. ")])])], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" Not Now ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleEnable
    }
  }, [_vm._v(" Enable Notifications ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }